import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.9995 14.9999C17.7735 14.9999 17.5465 14.9239 17.3595 14.7679L11.9885 10.2919L6.62651 14.6069C6.19751 14.9539 5.56751 14.8859 5.22051 14.4549C4.87451 14.0249 4.94251 13.3959 5.37351 13.0489L11.3735 8.22092C11.7435 7.92192 12.2745 7.92592 12.6405 8.23192L18.6405 13.2319C19.0645 13.5849 19.1215 14.2159 18.7685 14.6399C18.5705 14.8769 18.2865 14.9999 17.9995 14.9999Z"
    }, null, -1)
  ])))
}
export default { render: render }